/**
 * Copyright © 1998 - 2018 Tencent. All Rights Reserved.
 *
 * @author freedeng
 */

// 文本串解析的类型
enum PARSED_VALUE_TYPE {
    NUMBER = 0,
    STRING = 1,
    BOOL = 2,
    FORMULA = 3,
}

export default PARSED_VALUE_TYPE;
